/**
 * 首列单元格的内容工厂
 *
 * 纯 DOM 构造，不挂任何监听 —— 拖拽 icon 的 mousedown / contextmenu
 * 由 hooks/useRowDragDelegation 在根节点统一委托处理。
 *
 * 拆出的好处：
 * - 给 cellsCallback 的 renderer 提供单一入口，renderer 只负责 td.replaceChildren
 * - 与组件解耦后可独立单测（节点结构、class 名、icon src）
 */

/** 构造首列单元格的内容节点
 * @param value - 单元格文本
 * @param iconSrc - 拖拽 icon 图片路径
 * @param rowActionLabel - 行操作按钮的无障碍标签（由组件层传入，支持国际化）
 */
export const createFirstColumnContent = (value: string, iconSrc: string, rowActionLabel = 'Row actions'): HTMLDivElement => {
  const content = document.createElement('div');
  content.className = 'dba-smart-table-first-column-content';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'dba-smart-table-cell-action-icon';
  button.title = rowActionLabel;
  button.setAttribute('aria-label', rowActionLabel);

  const icon = document.createElement('img');
  icon.src = iconSrc;
  icon.alt = '';
  icon.className = 'dba-smart-table-cell-action-icon__img';
  button.appendChild(icon);

  const text = document.createElement('span');
  text.className = 'dba-smart-table-first-column-text';
  text.textContent = value;

  content.appendChild(button);
  content.appendChild(text);
  return content;
};
